import { useState } from 'react';
import { isBrandSignedOut } from '@/lib/auth/brandSignOut';
import { readJustLoggedOutFlag } from '@/lib/auth/clearSessionState';
import { useHubBrand } from '@/store';

type SignInSuppressed = { justLoggedOut: boolean; suppressed: boolean };

// gloss
export const useSignInSuppressed = (): SignInSuppressed => {
  const [justLoggedOut] = useState(() => readJustLoggedOutFlag());
  const signedOutOfThisHub = isBrandSignedOut(useHubBrand().uuid);

  return { justLoggedOut, suppressed: justLoggedOut || signedOutOfThisHub };
};
